import { Mail } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLanguage } from "../i18n/LanguageContext";
import { KineticWords } from "./KineticWords";

export const Faq = () => {
  const { t, lang } = useLanguage();

  return (
    <section id="faq" data-testid="faq-section" className="relative overflow-hidden py-28 sm:py-36 lg:py-40">
      <div className="relative mx-auto max-w-[1100px] px-4 sm:px-8">
        <span className="font-mono text-[11px] font-bold uppercase tracking-[0.35em] text-teal-400">
          04 · {t.faq.kicker[lang]}
        </span>
        <h2
          data-testid="faq-heading"
          className="font-display mt-6 text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-6xl"
        >
          <KineticWords key={lang} text={t.faq.heading[lang]} />
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{t.faq.subtext[lang]}</p>

        <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
          {t.faq.items.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-base font-semibold text-white transition-colors duration-200 hover:text-teal-300 hover:no-underline sm:text-lg [&>svg]:text-teal-400"
              >
                <span className="flex items-baseline gap-4">
                  <span className="font-mono text-xs font-bold text-teal-400/60">{String(i + 1).padStart(2, "0")}</span>
                  {item.q[lang]}
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="max-w-3xl text-sm leading-relaxed text-slate-400 sm:text-base"
              >
                {item.a[lang]}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <a
          href="mailto:info@zirsen.cz"
          data-testid="faq-contact-link"
          className="mt-10 inline-flex items-center gap-2 rounded-full border border-teal-400/30 bg-teal-400/10 px-6 py-3 text-sm font-semibold text-teal-200 transition-all duration-200 hover:border-teal-300 hover:bg-teal-400/20"
        >
          <Mail size={15} />
          {t.faq.contactCta[lang]}
        </a>
      </div>
    </section>
  );
};
